import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { ErrorInfoIconStyle } from './VerificationIcon.styles';

type Props = {
    tooltipText: string;
    isReadOnly?: boolean;
    isWarning?: boolean;
};

const ErrorInfoIcon: React.FC<Props> = (props) => {
    return (
        <>
            <ErrorInfoIconStyle isReadOnly={props.isReadOnly} isWarning={props.isWarning} title={props.tooltipText}>
                <FontAwesomeIcon icon="info-circle" />
            </ErrorInfoIconStyle>
        </>
    );
};

export default ErrorInfoIcon;
